import { TokenName } from "./colors";
import { toCssVarName } from "./cssVarName";

export const t = (k: TokenName): string => `var(--${toCssVarName(k)})`;
